import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { Button } from './Button';
const faqs = [{
  question: '¿Necesito comprar algo extra?',
  answer: 'No. El manual está diseñado para usarse con lo que ya tienes.'
}, {
  question: '¿Es apto para principiantes?',
  answer: 'Totalmente. Incluimos niveles desde cero hasta avanzado.'
}, {
  question: '¿Cuánto tiempo duran las rutinas?',
  answer: 'Entre 20 y 30 minutos máximo.'
}, {
  question: '¿El pago es único?',
  answer: 'Sí, pagas $17 una vez y tienes el acceso de por vida.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 bg-brand-darker" data-id="element-29">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-30">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-center mb-12" data-id="element-31">
          <h2 className="text-4xl md:text-5xl uppercase" data-id="element-32">
            PREGUNTAS <span className="text-brand-orange" data-id="element-33">FRECUENTES</span>
          </h2>
        </motion.div>

        <div className="space-y-4 mb-16" data-id="element-34">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.1
        }} className="border border-zinc-800 rounded-xl overflow-hidden bg-zinc-900/50" data-id="element-35">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-36">
                <span className="text-lg md:text-xl font-medium text-zinc-100" data-id="element-37">
                  {faq.question}
                </span>
                <ChevronDown className={`w-6 h-6 text-brand-orange transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-38" />
              </button>

              <AnimatePresence data-id="element-39">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-40">
                    <div className="px-6 pb-5 text-zinc-400 text-lg" data-id="element-41">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>

        <div className="flex justify-center" data-id="element-42">
          <Button data-id="element-43">¡SÍ, QUIERO EMPEZAR MI ENTRENAMIENTO AHORA!</Button>
        </div>
      </div>
    </section>;
}